import { LoadPickBonusCommand } from "slotworks/commands/comms/load-pick-bonus-command";
import BetModel from "slotworks/model/bets/bet-model";
import GameState from "slotworks/model/game-state";
import SmartUIFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import State from "slotworks/state-machine/states/state";
import Contract from "slotworks/utils/contracts/contract";

export default class RequestPickBonus extends State {

    public onEnter(cascadeSkip?: boolean) {
        super.onEnter();
    }

    public onExit() {
        SmartUIFlags.set(SmartUIFlag.AWAITING_RESPONSE, false);
    }

    protected sendBonusPick(pickIndex: number): Contract<any> {
        SmartUIFlags.set(SmartUIFlag.AWAITING_RESPONSE, true);
        return LoadPickBonusCommand(pickIndex).then(() => {
            if (!GameState.getCurrentGame().getCurrentRecord()) {
                this.error();
            } else {
                GameState.getCurrentGame().totalStake = BetModel.getTotalStake();
                this.complete();
            }
        });
    }
}
